import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-disapproval',
  templateUrl: './disapproval.component.html',
  styleUrls: ['./disapproval.component.css']
})
export class DisapprovalComponent implements OnInit {
  public comment= '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DisapprovalComponent>,
    ) { }

  ngOnInit() {
  }

  proceed() {
    if (this.comment ) {
    this.dialogRef.close( this.comment );
    }
  }
  cancel() {
    this.dialogRef.close();
  }
}
